<template>
  <div
    class="items mt-40"
  >
    <el-tabs
      v-if="balances.length > 1"
      type="card"
      class="user-balance"
    >
      <el-tab-pane
        v-for="(el, idx) of balances"
        v-model="activeBalance"
        :label="getRole(el.role)"
        :name="`${idx}`"
        :key="el.role"
      >
        <balance-data :balance="el" />
      </el-tab-pane>
    </el-tabs>
    <balance-data 
      v-else-if="this.balances.length === 1"
      :balance="this.balances[0]" 
    />
    <balance-data v-else />
    <el-row>
      <!-- <router-link
        v-if="(isEmployee && hasIban && !isTeamResp) || isTeamResp"
        :to="{ name: 'SelectTeam' }"
        custom
        v-slot="{ navigate }"
      >
        <el-button
          type="primary"
          class="primary-button"
          @click="navigate"
          style="margin-top: 10px;"
        >
          <span v-if="isTeamResp">{{ $t("re-conciliation.title") }}</span>
          <span v-if="isEmployee && hasIban && !isTeamResp">{{ $t("re-conciliation.transfer-to-iban") }}</span>
        </el-button>
      </router-link> -->


      <router-link
        v-if="isTeamResp"
        :to="{ name: 'SelectTeam' }"
        custom
        v-slot="{ navigate }"
      >
        <el-button
          type="primary"
          class="primary-button"
          @click="navigate"
          style="margin-top: 10px;"
        >
          {{ $t("re-conciliation.title") }}
        </el-button>
      </router-link>
      <el-button
        style="margin-top: 10px;"
        v-else-if="isEmployee && hasIban && !isTeamResp"
        type="primary"
        class="primary-button"
        @click="employeeReconciliationDialog = true"
      >
        {{ $t("re-conciliation.transfer-to-iban") }}
      </el-button>
    </el-row>
    <confirm-employee-reconciliation
      :visible.sync="employeeReconciliationDialog"
    />
  </div>
</template>

<script>
import ConfirmEmployeeReconciliation from "../../Reconciliation/Components/ConfirmEmployeeReconciliation";
import BalanceData from "./BalanceData.vue";

export default {
  name: "Balance",
  components: {
    ConfirmEmployeeReconciliation,
    BalanceData,
  },
  props: {
    balances: {
      type: Array,
      default: () => []
    },
    roles: {
      type: Array,
      default: () => []
    },
    hasIban: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    isTeamResp: false,
    isEmployee: false,
    fullScreenLoading: false,
    employeeReconciliationDialog: false,
    activeBalance: "1",
  }),
  async created() {
    this.isTeamResp = this.roles.includes('team-representative')
    this.isEmployee = this.roles.includes('employee')
  },
  methods: {
    getRole(role) {
      let selectedRole = "";
      switch (role) {
        case "employee":
          selectedRole = this.$t("users.employee");
          break;
        case "business-representative":
          selectedRole = this.$t("users.business");
          break;
        case "team-representative":
          selectedRole = this.$t("users.team");
          break;
      }
      return selectedRole;
    },
  },
};
</script>

<style lang="scss">
.user-balance {
  .el-tabs__header {
    margin-bottom: 30px;
  }
}
</style>